import React, { forwardRef } from 'react'

import { Spinner } from '@/components/spinner'

import { TSinglePlanProps } from './types'

// eslint-disable-next-line react/display-name
export const SinglePlan = forwardRef<HTMLDivElement, TSinglePlanProps>(({ plans }, ref) => {
  if (!plans.length) {
    return (
      <div className="single-plan-container" ref={ref}>
        <Spinner />
      </div>
    )
  }

  const plan = plans[0]

  return (
    <div className="single-plan-container" ref={ref}>
      <form className="plans-form">
        <React.Fragment key={plan.planId}>
          <div className="price-description-container trial">
            <div className="price-title">Price Today</div>
            <div className="price-description">
              <div className="name">7-day trial</div>
              <div className="full-amount">
                {plan.currencySign}
                {plan.trialPrice}
              </div>
            </div>
          </div>
          <div className="horizontal-line" />
          <div className="price-description-container">
            <div className="price-title">Price after Trial</div>
            <div className="price-description">
              <div className="name">6-month plan</div>
              <div className="weekly-amount">
                {plan.currencySign}
                {plan.periodPrice}/{plan.periodLabel}
              </div>
            </div>

            <div className="price-description">
              <div className="monthly-amount">
                *{plan.currencySign}
                {plan.price} billed on {plan.formattedDate} unless cancelled beforehand
              </div>
            </div>
          </div>
        </React.Fragment>
      </form>
    </div>
  )
})
